/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ActionCard extends Component {
    static propTypes = {
        title: PropTypes.string,
        controlsLeft: PropTypes.node,
        controlsRight: PropTypes.node,
        children: PropTypes.node,
        className: PropTypes.string,
        headerOnClick: PropTypes.func
    };
    
    static defaultProps = {
        className: ""
    };

    render() {
        return (
            <div className={`action-card ${this.props.className}`}>
                <div className={`action-card-header ${(this.props.headerOnClick ? "is-clickable" : "")}`} onClick={this.props.headerOnClick}>
                    <div className="action-card-title">
                        {this.props.title}
                        {this.props.controlsLeft}
                    </div>
                    <div className="action-card-controls-right">
                        {this.props.controlsRight}
                    </div>
                </div>
                <div className="action-card-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/ActionCard/ActionCard.js